import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

// Özel alan adı (örn. birligim.com) /api yolunu backend'e proxy'ler; çapraz-kaynak çerez/CORS sorununu önlemek için aynı kaynağı kullan
const resolveBase = () => {
  const backendHost = BACKEND_URL ? new URL(BACKEND_URL).host : "";
  const { protocol, host, origin } = window.location;
  const isCustomDomain = protocol === "https:" && backendHost && host !== backendHost && !host.includes("localhost");
  return isCustomDomain ? origin : BACKEND_URL;
};

export const API = `${resolveBase()}/api`;

export const http = axios.create({
  baseURL: API,
  withCredentials: true,
});

export const formatTRY = (n) =>
  new Intl.NumberFormat("tr-TR", { style: "currency", currency: "TRY", maximumFractionDigits: 0 }).format(n || 0);

export const CATEGORIES = [
  { value: "ev", label: "Ev Temizliği", color: "emerald", hex: "#10B981" },
  { value: "insaat", label: "İnşaat Sonrası", color: "amber", hex: "#F59E0B" },
  { value: "ofis", label: "Ofis Temizliği", color: "sky", hex: "#0284C7" },
  { value: "yonetim", label: "Yönetim / Genel", color: "indigo", hex: "#4F46E5" },
];

export const catByValue = (v) => CATEGORIES.find((c) => c.value === v) || CATEGORIES[0];

export const RECURRING = [
  { value: "yok", label: "Tekrar Yok" },
  { value: "gunluk", label: "Günlük" },
  { value: "haftalik", label: "Haftalık" },
  { value: "aylik", label: "Aylık" },
];

export const STATUS = [
  { value: "planlandi", label: "Planlandı", color: "bg-amber-100 text-amber-800 dark:bg-amber-950 dark:text-amber-300" },
  { value: "tamamlandi", label: "Tamamlandı", color: "bg-emerald-100 text-emerald-800 dark:bg-emerald-950 dark:text-emerald-300" },
  { value: "iptal", label: "İptal", color: "bg-red-100 text-red-800 dark:bg-red-950 dark:text-red-300" },
];
